export default __webpack_public_path__ + "static/media/done-checkmarkKeto.82e9b9c4.svg";